export function BlockEditor() {
    return <div>Block editor</div>;
}
